import { Avatar, Button, Checkbox, Col, DatePicker, Form, Input, Row, Select } from "antd"
import React, { useEffect, useRef, useState } from "react"
import TextUtils from "../../../helpers/TextUtils"
import { SexList } from "../../../constants/bilet-constant"
import UserManager from "../../../manager/UserManager"
import moment from "moment"
import { useUser } from "../../../hooks/useUser"
import { baseUrl } from "../../../constants/environment"
import APIClient from "../../../helpers/APIClient"
import { toast } from "react-toastify"
import dayjs from 'dayjs';
import Loader from "../../../components/Loader"
import { isEmpty, startsWith } from "lodash"
import noImage from "../../../assets/images/users/no-img.jpg";
import { FileUploader } from "react-drag-drop-files"
import { getBase64, uploadFile } from "../../../helpers/UploadUtils"

const List = (props: any) => {
    const user = useUser();
    const [loading, setLoading] = useState<any>(false)
    const [data, setData] = useState<any>({})
    const formRef = useRef<any>(null)
    const [imgAvatar, setimgAvatar] = useState<any>(null)
    useEffect(() => {
        setData({
            ...user,
            birthday: moment(user?.birthday)?.valueOf()
        })
    }, [user]);
    const handleChangeInput = (event?: any) => {
        let { value, name } = event.target;
        if (value === " ") return;
        if (name == 'phone') {
            value = TextUtils.onlyNumber(value)
        }
        setData({
            ...data,
            [name]: value,
        });
    };

    const validation = () => {
        if (!isEmpty(data?.email) && !TextUtils.validateEmail(data?.email)) {
            toast.error("Email không đúng định dạng")
            return false
        }
        if (!isEmpty(data?.phone) && !TextUtils.validatePhone(data?.phone)) {
            toast.error("Số điện thoại không đúng định dạng")
            return false
        }
        return true
    }

    const _onChangeDate = (date: any) => {
        setData({
            ...data,
            birthday: date ? moment(date).valueOf() : null
        })
    }

    const updateStatus = async () => {
        const URL = `${baseUrl}/admin/user/${data?.id}`
        const params: any = {
            status: data?.status
        }
        setLoading(true)
        let response: any = await APIClient.PUT(URL, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description);
        } else if (response.response !== undefined) {

        }
    }


    const handleSubmit = async () => {
        await formRef?.current?.validateFields()
        updateStatus()
        setLoading(true)
        if (!validation()) return
        const URL = `${baseUrl}/auth/me`
        const params: any = {
            name: data?.name,
            sex: data?.sex,
            birthday: data?.birthday,
            email: data?.email,
            phone: data?.phone,
            status: data?.status
        }

        if (!!imgAvatar) {
            const url_avatar: any = await uploadFile(imgAvatar);
            if (url_avatar && startsWith(url_avatar, 'http')) {
                params.avatar = url_avatar;
            } else {
                toast.error("Không thể tải ảnh lên ảnh đại diện");
                return false;
            }
        }
        let response: any = await APIClient.PUT(URL, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description);
        } else if (response.response !== undefined) {
            UserManager._getUserInfo()
            toast.success("Chỉnh sửa thông tin thành công!")
        }
    }
    const handleChangeFile = async (file: any) => {
        setLoading(true);
        const imgBase64: any = await getBase64(file);
        setLoading(false);
        if (imgBase64) {
            setData({
                ...data,
                avatar: imgBase64,
            });
        }
        setimgAvatar(file)
    };
    return (
        <Form
            ref={formRef}
            wrapperCol={{ flex: 1 }}
            layout="vertical"
            autoComplete="off"
            className="form_normal"
            fields={[
                { name: "name", value: data.name },
                { name: "email", value: data.email },
            ]}
        >
            <Row gutter={[50, 0]}>
                <Col md={24} xs={24}>
                    <Form.Item label="" style={{ display: 'inline-flex' }}>
                        <FileUploader
                            handleChange={(e: any) => {
                                handleChangeFile(e);
                                setimgAvatar(null);
                            }}
                            fileOrFiles={imgAvatar}
                            multiple={false}
                            name="file"
                            types={["JPEG", "JPG", "PNG"]}
                            classes="file-drop-inner upload__file"
                        >
                            <Avatar
                                src={data?.avatar || noImage}
                                alt="avatar"
                                style={{ width: 70, height: 70 }}
                            />
                            <div className="icon_upload">
                                <i className="uil-camera-change"></i>
                            </div>

                        </FileUploader>

                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item label="Họ và tên" name={'name'} rules={[{ required: true, message: "Họ và tên là bắt buộc" }]} >
                        <Input onChange={(e: any) => handleChangeInput(e)} allowClear value={data?.name} name="name" placeholder="Nhập họ tên" />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item label="Giới tính">
                        <Select
                            placeholder="Chọn giới tính"
                            onChange={(vl: string) =>
                                setData({ ...data, sex: vl })
                            }
                            value={data?.sex}
                            style={{ flex: 1, fontSize: 16 }}
                            dropdownStyle={{ minWidth: 200 }}
                            allowClear
                        // filterOption={(input, option: any) => {
                        //     return TextUtils.removeVietNamese(option.children?.toString()?.toLowerCase()).indexOf(TextUtils.removeVietNamese(input.toLowerCase())) !== -1
                        // }}
                        >
                            {SexList?.map((item: any) => (
                                <Select.Option value={item.value}>
                                    {item.label}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item label="ID giới thiệu" >
                        <div className="d-flex align-items-center" style={{ fontSize: 16, minHeight: 44 }}>{data?.referral_code || '---'}</div>
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item label="Ngày sinh" valuePropName={'birthday'}>
                        <DatePicker
                            onChange={_onChangeDate}
                            name="birthday"
                            placeholder="Chọn ngày sinh"
                            format={"DD/MM/YYYY"}
                            value={data?.birthday && moment(data?.birthday)}
                            allowClear
                            suffixIcon={<i className="uil-calendar-alt"></i>}
                        />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item label="Email" name={'email'} rules={[{ required: true, message: "Email là bắt buộc" }]}>
                        <Input onChange={(e: any) => handleChangeInput(e)} allowClear name="email" value={data?.email} placeholder="Nhập Email" />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item label="Số điện thoại">
                        <Input onChange={(e: any) => handleChangeInput(e)} type="text" allowClear name="phone" value={data?.phone} placeholder="Nhập số điện thoại" />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item label="Ngày tạo">
                        <div className="d-flex align-items-center" style={{ fontSize: 16, minHeight: 44 }}>{moment(data?.created_time).format('DD/MM/YYYY HH:mm')}</div>
                    </Form.Item>
                </Col>
            </Row>
            <div className="mt-3 d-flex align-items-center justify-content-between">
                <Checkbox checked={data?.status == 1 ? true : false} onChange={(event: any) => setData({ ...data, status: event?.target?.checked ? 1 : 0 })}>Hoạt động</Checkbox>
                <Button className="bilet_button" onClick={handleSubmit}>Lưu</Button>
            </div>
            {
                loading && <Loader />
            }
        </Form>
    )
}
export default List